import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Speaker.svg'

export const IconSpeaker = IconSVG as IconComponent
